import type { Account } from "bonusx-api-main-manager";
import { accountApi } from "../../../legacy/services/main-account-api-instance";

export async function getMe(): Promise<Account> {
  const response = await accountApi.getMe();
  return response.data;
}

export { accountApi };
